query ApprovalHistoryBranches($id: UUID!) {
  approvalHistoryBranches(
    orderBy: [TREE_APPROVAL_LEVEL_DESC, APPROVER_NAME_ASC]
    filter: { entityApprovalId: { equalTo: $id } }
  ) {
    nodes {
      id
      _rowTimestamp
      _isAddNewApproverAllowed
      approverName
      actionDate
      _isBranchBypassAllowed
      _isBranchReplaceAllowed
      comments
      statusType {
        approvalState
        statusType
      }
      approverUserProfileId
      treeDescription
      treeApprovalLevel
      entityApprovalId
    }
  }
}